import 'css-chunk:src/applications/AffiliatesApp/components/DeeplinkDrawer/DisplayDeeplinks.scss';export default {
  "deeplinksList": "_deeplinksList_1d7gn_1",
  "collapseBg": "_collapseBg_1d7gn_9"
};